export const phoneCountries = [
  { value: '+1', label: 'US' },
  { value: '+1', label: 'CA' },
  { value: '+1242', label: 'BS' },
  { value: '+1246', label: 'BB' },
  { value: '+1264', label: 'AI' },
  { value: '+1268', label: 'AG' },
  { value: '+1284', label: 'VG' },
  { value: '+1340', label: 'VI' },
  { value: '+1345', label: 'KY' },
  { value: '+1441', label: 'BM' },
  { value: '+1473', label: 'GD' },
  { value: '+1649', label: 'TC' },
  { value: '+1664', label: 'MS' },
  { value: '+1670', label: 'MP' },
  { value: '+1671', label: 'GU' },
  { value: '+1684', label: 'AS' },
  { value: '+1721', label: 'SX' },
  { value: '+1758', label: 'LC' },
  { value: '+1767', label: 'DM' },
  { value: '+1784', label: 'VC' },
  { value: '+1787', label: 'PR' },
  { value: '+1809', label: 'DO' },
  { value: '+1868', label: 'TT' },
  { value: '+1869', label: 'KN' },
  { value: '+1876', label: 'JM' },
  { value: '+20', label: 'EG' },
  { value: '+211', label: 'SS' },
  { value: '+212', label: 'MA' },
  { value: '+213', label: 'DZ' },
  { value: '+216', label: 'TN' },
  { value: '+218', label: 'LY' },
  { value: '+220', label: 'GM' },
  { value: '+221', label: 'SN' },
  { value: '+222', label: 'MR' },
  { value: '+223', label: 'ML' },
  { value: '+224', label: 'GN' },
  { value: '+225', label: 'CI' },
  { value: '+226', label: 'BF' },
  { value: '+227', label: 'NE' },
  { value: '+228', label: 'TG' },
  { value: '+229', label: 'BJ' },
  { value: '+230', label: 'MU' },
  { value: '+231', label: 'LR' },
  { value: '+232', label: 'SL' },
  { value: '+233', label: 'GH' },
  { value: '+234', label: 'NG' },
  { value: '+235', label: 'TD' },
  { value: '+236', label: 'CF' },
  { value: '+237', label: 'CM' },
  { value: '+238', label: 'CV' },
  { value: '+239', label: 'ST' },
  { value: '+240', label: 'GQ' },
  { value: '+241', label: 'GA' },
  { value: '+242', label: 'CG' },
  { value: '+243', label: 'CD' },
  { value: '+244', label: 'AO' },
  { value: '+245', label: 'GW' },
  { value: '+246', label: 'IO' },
  { value: '+248', label: 'SC' },
  { value: '+249', label: 'SD' },
  { value: '+250', label: 'RW' },
  { value: '+251', label: 'ET' },
  { value: '+252', label: 'SO' },
  { value: '+253', label: 'DJ' },
  { value: '+254', label: 'KE' },
  { value: '+255', label: 'TZ' },
  { value: '+256', label: 'UG' },
  { value: '+257', label: 'BI' },
  { value: '+258', label: 'MZ' },
  { value: '+260', label: 'ZM' },
  { value: '+261', label: 'MG' },
  { value: '+262', label: 'YT' },
  { value: '+262', label: 'RE' },
  { value: '+263', label: 'ZW' },
  { value: '+264', label: 'NA' },
  { value: '+265', label: 'MW' },
  { value: '+266', label: 'LS' },
  { value: '+267', label: 'BW' },
  { value: '+268', label: 'SZ' },
  { value: '+269', label: 'KM' },
  { value: '+27', label: 'ZA' },
  { value: '+290', label: 'SH' },
  { value: '+291', label: 'ER' },
  { value: '+297', label: 'AW' },
  { value: '+298', label: 'FO' },
  { value: '+299', label: 'GL' },
  { value: '+30', label: 'GR' },
  { value: '+31', label: 'NL' },
  { value: '+32', label: 'BE' },
  { value: '+33', label: 'FR' },
  { value: '+34', label: 'ES' },
  { value: '+350', label: 'GI' },
  { value: '+351', label: 'PT' },
  { value: '+352', label: 'LU' },
  { value: '+353', label: 'IE' },
  { value: '+354', label: 'IS' },
  { value: '+355', label: 'AL' },
  { value: '+356', label: 'MT' },
  { value: '+357', label: 'CY' },
  { value: '+358', label: 'FI' },
  { value: '+359', label: 'BG' },
  { value: '+36', label: 'HU' },
  { value: '+370', label: 'LT' },
  { value: '+371', label: 'LV' },
  { value: '+372', label: 'EE' },
  { value: '+373', label: 'MD' },
  { value: '+374', label: 'AM' },
  { value: '+375', label: 'BY' },
  { value: '+376', label: 'AD' },
  { value: '+377', label: 'MC' },
  { value: '+378', label: 'SM' },
  { value: '+379', label: 'VA' },
  { value: '+380', label: 'UA' },
  { value: '+381', label: 'RS' },
  { value: '+382', label: 'ME' },
  { value: '+383', label: 'XK' },
  { value: '+385', label: 'HR' },
  { value: '+386', label: 'SI' },
  { value: '+387', label: 'BA' },
  { value: '+389', label: 'MK' },
  { value: '+39', label: 'IT' },
  { value: '+40', label: 'RO' },
  { value: '+41', label: 'CH' },
  { value: '+420', label: 'CZ' },
  { value: '+421', label: 'SK' },
  { value: '+423', label: 'LI' },
  { value: '+43', label: 'AT' },
  { value: '+44', label: 'GB' },
  { value: '+45', label: 'DK' },
  { value: '+46', label: 'SE' },
  { value: '+47', label: 'NO' },
  { value: '+47', label: 'SJ' },
  { value: '+48', label: 'PL' },
  { value: '+49', label: 'DE' },
  { value: '+500', label: 'FK' },
  { value: '+501', label: 'BZ' },
  { value: '+502', label: 'GT' },
  { value: '+503', label: 'SV' },
  { value: '+504', label: 'HN' },
  { value: '+505', label: 'NI' },
  { value: '+506', label: 'CR' },
  { value: '+507', label: 'PA' },
  { value: '+508', label: 'PM' },
  { value: '+509', label: 'HT' },
  { value: '+51', label: 'PE' },
  { value: '+52', label: 'MX' },
  { value: '+53', label: 'CU' },
  { value: '+54', label: 'AR' },
  { value: '+55', label: 'BR' },
  { value: '+56', label: 'CL' },
  { value: '+57', label: 'CO' },
  { value: '+58', label: 'VE' },
  { value: '+590', label: 'BL' },
  { value: '+590', label: 'MF' },
  { value: '+591', label: 'BO' },
  { value: '+592', label: 'GY' },
  { value: '+593', label: 'EC' },
  { value: '+595', label: 'PY' },
  { value: '+597', label: 'SR' },
  { value: '+598', label: 'UY' },
  { value: '+60', label: 'MY' },
  { value: '+61', label: 'AU' },
  { value: '+61', label: 'CX' },
  { value: '+61', label: 'CC' },
  { value: '+62', label: 'ID' },
  { value: '+63', label: 'PH' },
  { value: '+64', label: 'NZ' },
  { value: '+64', label: 'PN' },
  { value: '+65', label: 'SG' },
  { value: '+66', label: 'TH' },
  { value: '+670', label: 'TL' },
  { value: '+672', label: 'AQ' },
  { value: '+673', label: 'BN' },
  { value: '+674', label: 'NR' },
  { value: '+675', label: 'PG' },
  { value: '+676', label: 'TO' },
  { value: '+677', label: 'SB' },
  { value: '+678', label: 'VU' },
  { value: '+679', label: 'FJ' },
  { value: '+680', label: 'PW' },
  { value: '+681', label: 'WF' },
  { value: '+682', label: 'CK' },
  { value: '+683', label: 'NU' },
  { value: '+685', label: 'WS' },
  { value: '+686', label: 'KI' },
  { value: '+687', label: 'NC' },
  { value: '+688', label: 'TV' },
  { value: '+689', label: 'PF' },
  { value: '+690', label: 'TK' },
  { value: '+691', label: 'FM' },
  { value: '+692', label: 'MH' },
  { value: '+7', label: 'KZ' },
  { value: '+7', label: 'RU' },
  { value: '+81', label: 'JP' },
  { value: '+82', label: 'KR' },
  { value: '+84', label: 'VN' },
  { value: '+850', label: 'KP' },
  { value: '+852', label: 'HK' },
  { value: '+853', label: 'MO' },
  { value: '+855', label: 'KH' },
  { value: '+856', label: 'LA' },
  { value: '+86', label: 'CN' },
  { value: '+880', label: 'BD' },
  { value: '+886', label: 'TW' },
  { value: '+90', label: 'TR' },
  { value: '+91', label: 'IN' },
  { value: '+92', label: 'PK' },
  { value: '+93', label: 'AF' },
  { value: '+94', label: 'LK' },
  { value: '+95', label: 'MM' },
  { value: '+960', label: 'MV' },
  { value: '+961', label: 'LB' },
  { value: '+962', label: 'JO' },
  { value: '+963', label: 'SY' },
  { value: '+964', label: 'IQ' },
  { value: '+965', label: 'KW' },
  { value: '+966', label: 'SA' },
  { value: '+967', label: 'YE' },
  { value: '+968', label: 'OM' },
  { value: '+970', label: 'PS' },
  { value: '+971', label: 'AE' },
  { value: '+972', label: 'IL' },
  { value: '+973', label: 'BH' },
  { value: '+974', label: 'QA' },
  { value: '+975', label: 'BT' },
  { value: '+976', label: 'MN' },
  { value: '+977', label: 'NP' },
  { value: '+98', label: 'IR' },
  { value: '+992', label: 'TJ' },
  { value: '+993', label: 'TM' },
  { value: '+994', label: 'AZ' },
  { value: '+995', label: 'GE' },
  { value: '+996', label: 'KG' },
  { value: '+998', label: 'UZ' },
]; 